import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, Button, cls } from '../../packages/components';
import './styles/AAFModalService.scss';

const AAFModalService = (props = {}) => {
    const ServiceType = () => {
      return (
        <Row>
          {props.services.map((m) => {
            return (
              <Row>
                <Column lg={12} key={m.service_id}>
                  <Button
                    activate
                    type="button"
                    className={cls('focusable', 'modal-button-services')}
                    onClick= {(e) => props.handleClose(e, props.service(m.service_id))}                            >
                    {`${m.service_id}-${m.service_name}`}
                  </Button>
                </Column>
              </Row>
            );
          })}
        </Row>
      );
    };
    const p = {
      alwaysEnabled: true,
      buttonsAlign: 'vertical',
      aafNewStyle: true,
      className: 'aaf-modal',
      showLogo: false,
    };
    return (
      <ModalWrapper {...p}>
        <ServiceType />
      </ModalWrapper>
    );
};

AAFModalService.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default withOnClose(AAFModalService);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalService.jsx